module.exports = __webpack_public_path__ + "images/emoji/smirk.44b0d79ea63e9bc1a674.png";